import gql from 'graphql-tag'

export const FETCH_PROGRESS_AND_CERTIFICATIONS = gql`
  query FETCH_PROGRESS_AND_CERTIFICATIONS($l2Code: LanguageEnum!) {
    currentUser {
      certifications(code: $l2Code) {
        cefrLevel
        progress
        description
        completedAt
        linkUrl
      }
      progress(code: $l2Code) {
        cefrLevel {
          code
          label
        }
        cefrLevelProgress
      }
    }
  }
`

export const FETCH_WRITING_DATA = gql`
  query FETCH_WRITING_DATA($l2Code: LanguageEnum!) {
    currentUser {
      progress(code: $l2Code) {
        stats(
          period: total
          kinds: [writing_completed, writing_tutor_correction]
        ) {
          count
          kind
        }
      }
      writing: lastActivity(code: $l2Code, type: journal) {
        identifier
        heading
        coverImageUrl
        lastSeenTimeAgo
        cefrLevel
        unit {
          name
        }
      }
    }
  }
`

export const FETCH_MEDIA_DATA = gql`
  query FETCH_MEDIA_DATA($l2Code: LanguageEnum!) {
    currentUser {
      progress(code: $l2Code) {
        stats(period: total, kinds: [media_mastered, media_completed]) {
          count
          kind
        }
      }
      media: lastActivity(code: $l2Code, type: media) {
        identifier
        heading
        coverImageUrl
        lastSeenTimeAgo
        cefrLevel
        unit {
          name
        }
      }
    }
  }
`
export const FETCH_CONCEPTS_DATA = gql`
  query FETCH_CONCEPTS_DATA($l2Code: LanguageEnum!) {
    currentUser {
      progress(code: $l2Code) {
        stats(period: total, kinds: [concepts_completed]) {
          count
          kind
        }
      }
      concept: lastActivity(code: $l2Code, type: conceptexplanation) {
        identifier
        heading
        coverImageUrl
        lastSeenTimeAgo
        cefrLevel
        unit {
          name
        }
      }
    }
  }
`

export const FETCH_APPOINTMENT_DATA = gql`
  query FETCH_APPOINTMENT_DATA($l2Code: LanguageEnum!) {
    currentUser {
      progress(code: $l2Code) {
        stats(
          period: total
          kinds: [
            live_lesson_total_lessons
            live_lesson_total_exercises
            live_lesson_exercises_feeling_good
            live_lesson_total_hours
          ]
        ) {
          count
          kind
        }
      }
      appointment: lastAppointment(code: $l2Code) {
        updatedAt
        chatSessionId
        averageStudentRating
        tutor {
          login
          name
          avatarUrl
          tutor {
            isFavorite
          }
        }
        exercises(last: 1) {
          nodes {
            imageUrl
          }
        }
        unit {
          cefrLevel
          name
        }
        lastSeenTimeAgo
        chatSessionArchiveUrl
      }
    }
  }
`

export const FETCH_STATS_DATA = gql`
  query FETCH_STATS_DATA($l2Code: LanguageEnum!) {
    currentUser {
      progress(code: $l2Code) {
        stats(
          period: total
          kinds: [
            live_lesson_total_lessons
            live_lesson_total_exercises
            live_lesson_exercises_feeling_good
            live_lesson_total_hours
            media_mastered
            media_completed
            writing_completed
            writing_tutor_correction
            concepts_completed
            minutes
          ]
        ) {
          count
          kind
        }
      }
    }
  }
`

export const FETCH_FLASHCARDS_DATA = gql`
  query FETCH_FLASHCARDS_DATA($l2Code: LanguageEnum!) {
    currentUser {
      lastCardActivity(code: $l2Code) {
        duration
        cefrLevel
        unitName
        lastSeenTimeAgo
      }
      progress(code: $l2Code) {
        knownCards: stats(
          period: three_months
          kinds: [known_cards]
          interval: daily
        ) {
          count
          time
        }
        learningCards: stats(
          period: three_months
          kinds: [learning_cards]
          interval: daily
        ) {
          count
          time
        }
        totalKnownCards: stats(period: total, kinds: [known_cards]) {
          count
        }
        totalCards: stats(period: total, kinds: [cards]) {
          count
        }
        totalMinutesCards: stats(period: total, kinds: [cards_minutes]) {
          count
        }
      }
    }
  }
`

export const FETCH_LEADERBOARD_DATA = gql`
  query FETCH_LEADERBOARD_DATA {
    leaderBoard {
      name
      topPositions {
        user {
          id
          login
          avatarUrl
        }
        studyTime
        rank
        languages {
          code
        }
      }
      currentUserPosition {
        user {
          id
          login
          avatarUrl
        }
        studyTime
        rank
        languages {
          code
        }
      }
      countOfMembers
    }
  }
`
